import DashboardIncidentsMainBranch from './DashboardIncidentsMainBranch';

export default DashboardIncidentsMainBranch;
